import { render, staticRenderFns } from "./edit_historial.vue?vue&type=template&id=62179546"
import script from "./edit_historial.vue?vue&type=script&lang=js"
export * from "./edit_historial.vue?vue&type=script&lang=js"
import style0 from "./edit_historial.vue?vue&type=style&index=0&id=62179546&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports